module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 5
// module chunks = 2 3